<section class="form_section">
    <div class="dialog-header">
        <button mat-icon-button (click)="cerrarDialogo()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <h2>Registrar Deudor</h2>
    <form action="" class="form_register_minutes" [formGroup]="form" (ngSubmit)="submit()">
        <section class="container-form">
            <mat-form-field class="example-form-field">
                <mat-label>Rut de Deudor</mat-label>
                <input matInput formControlName="clientRut" (blur)="inputRut($event)" />
            </mat-form-field>
            <div *ngIf="form.controls['clientRut'].errors?.['invalidRut']">
                <ng-container *ngIf="form.controls['clientRut'].errors?.['invalidRut']">
                    Este RUT es inválido.
                </ng-container>
            </div>
            <mat-form-field class="example-form-field">
                <mat-label>Clave SII (Opcional)</mat-label>
                <input matInput type="text" formControlName="siiPass" />
              </mat-form-field>

        </section>
        <section class="button_class">
            <button [disabled]="!form.valid || cargandoBtn" mat-stroked-button color="primary" type="submit" class="w-50">
                <span *ngIf="!cargandoBtn">Registrar</span>
                <span *ngIf="cargandoBtn">
                  <i class="fas fa-spinner fa-spin"></i> Cargando...
                </span>
            </button>
        </section>
    </form>
</section>
